import React from 'react';
import { Alert, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const SuccessMessage = () => {
    //Store
    const paymentLotsMessage = useSelector( state => state.paymentLots.message );
    const paidoutLot = useSelector( state => state.paymentLots.paidoutLot );
    //Render
    return (
        paymentLotsMessage && paymentLotsMessage.trim() !== '' ? (
            <Col xs={12}>
                <Alert variant="success">
                    { paymentLotsMessage }
                    {
                        paidoutLot && paidoutLot.voucher ? (
                            <>
                                <br />
                                Si no se descargó la boleta de pago automáticamente, puede hacerlo manualmente desde&nbsp; 
                                <a href={paidoutLot.voucher} target="_blank" rel="noopener noreferrer"><strong>AQUÍ</strong></a>
                            </>
                        ) : null
                    }
                </Alert>
            </Col>
        ) : null
    );
};

export default SuccessMessage;